import { Vector3 } from '@babylonjs/core';
import { EnemyDistributionConfig } from '../EnemyGenerator';
import { ENEMY_ANIMATIONS, EnemyBehavior } from './EnemyBehavior';

/**
 * Patrol behavior - walk left/right along lateral axis
 */

export class EnemyPatrolBehavior extends EnemyBehavior {
  private direction: number = 1;
  private patrolProgress: number = 0;

  constructor(startPosition: Vector3, config: EnemyDistributionConfig) {
    config.sound = {
      name: 'enemywalk',
      autoplay: true,
    };
    super('enemyPatrol', startPosition, config);
  }

  behaviorUpdate(deltaTime: number): void {
    // Play walk animation
    this.playAnimation(ENEMY_ANIMATIONS.WALK, true);

    // Move along patrol path
    this.patrolProgress += this.config.speed * deltaTime * this.direction;

    // Reverse at ends
    if (Math.abs(this.patrolProgress) >= this.config.patrolWidth / 2) {
      this.direction *= -1;
      this.patrolProgress = Math.sign(this.patrolProgress) * (this.config.patrolWidth / 2);
    }

    // Calculate new position
    this.mesh.position.x = this.startPosition.x + this.patrolProgress;
    this.mesh.position.z = this.startPosition.z;
    // this.mesh.position.y = this.startPosition.y; // removed to use snapToGround
    this.snapToGround(deltaTime);

    // Face movement direction
    this.mesh.rotation.y = this.direction > 0 ? Math.PI / 2 : -Math.PI / 2;
  }

  clone(): EnemyPatrolBehavior {
    return new EnemyPatrolBehavior(this.startPosition, this.config);
  }
}
